import { render, staticRenderFns } from "./keyword-edit.vue?vue&type=template&id=b713b634&"
import script from "./keyword-edit.vue?vue&type=script&lang=js&"
export * from "./keyword-edit.vue?vue&type=script&lang=js&"
import style0 from "./keyword-edit.vue?vue&type=style&index=0&id=b713b634&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports